module.exports = __webpack_public_path__ + "static/media/jsLogo.cdb6cb18.png";